import React, { useState, useEffect, useMemo } from 'react';
import { TextField} from '@mui/material';
import { FaReceipt } from "react-icons/fa6";
import { IoMdMail } from "react-icons/io";
import { IoAddCircleSharp } from "react-icons/io5";
import { FaUserCheck } from "react-icons/fa";
import MemberModal from './components/MemberModal';
import axios from 'axios';
import { MdEdit } from "react-icons/md";
import { API_BASE_URL } from '../../App.js';

const Members = () => {
    const [players, setPlayers] = useState([]);
    const [show, setShow] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [selectedPlayer, setSelectedPlayer] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('all'); // all, active, inactive
    const [roleFilter, setRoleFilter] = useState('all'); // all, admin, trainer, member


    useEffect(() => {
        axios.get(`${API_BASE_URL}/api/allplayersadmin`)
            .then((response) => setPlayers(response.data))
            .catch((error) => {
                console.error("Es gab ein Problem beim Abrufen der Daten: ", error);
            });
    }, []);

    const filteredPlayers = useMemo(() =>
        players
            .filter(player => {
                const guestEmail = (process.env.REACT_APP_GUEST_EMAIL || 'gast@tc-opfingen.de').toLowerCase();

                // Exclude Guest User
                if (player.email && player.email.toLowerCase() === guestEmail) return false;

                // Search Term Filter
                const matchesSearch = (
                    player.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    player.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    player.email.toLowerCase().includes(searchTerm.toLowerCase())
                );

                // Status Filter
                let matchesStatus = true;
                if (statusFilter === 'active') matchesStatus = player.isActive;
                if (statusFilter === 'inactive') matchesStatus = !player.isActive;

                // Role Filter
                let matchesRole = true;
                if (roleFilter === 'admin') matchesRole = player.role === 2;
                if (roleFilter === 'trainer') matchesRole = player.role === 1;
                if (roleFilter === 'member') matchesRole = player.role === 0;

                return matchesSearch && matchesStatus && matchesRole;
            })
        , [players, searchTerm, statusFilter, roleFilter]);





    const closeModal = () => {
        setShow(false);
        setEditMode(false);
        setSelectedPlayer(null); // Zurücksetzen
    };

    const showCreateModal = () => {
        setShow(true);
        setEditMode(false);
        setSelectedPlayer(null); // Erstellen-Modus
    };

    const showEditModal = (player) => {
        setShow(true);
        setEditMode(true); // Bearbeiten-Modus
        setSelectedPlayer(player); // Spieler setzen
    };

    return (
        <div className='bg-white rounded shadow-sm'>
            <div className="container-fluid p-0 d-none d-md-block">
                <div className='text-center pt-3 fw-semibold fs-4 text-danger'>Mitgliederverwaltung
                    <IoAddCircleSharp className='rounded-5 mx-2 add-button' size={39} onClick={showCreateModal} />
                </div>

                <div className='text-center align-items-center my-4 d-flex justify-content-center mx-3'>
                    <TextField
                        label="Suche: Name/E-Mail"
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        size="small"
                        className="me-2"
                    />

                    <select
                        className="form-select w-auto me-2"
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                    >
                        <option value="all">Alle Status</option>
                        <option value="active">Aktiv</option>
                        <option value="inactive">Inaktiv</option>
                    </select>

                    <select
                        className="form-select w-auto me-2"
                        value={roleFilter}
                        onChange={(e) => setRoleFilter(e.target.value)}
                    >
                        <option value="all"> Rollen</option>
                        <option value="member">Mitglied</option>
                        <option value="trainer">Trainer</option>
                        <option value="admin">Admin</option>
                    </select>
                </div>
            </div>

            <div className="container-fluid p-0 pt-2 d-md-none d-block mb-2">
                <div className='text-center pt- fw-semibold fs-5 text-danger'>Mitgliederverwaltung
                    <IoAddCircleSharp className='rounded-5 mx-2 add-button' size={29} onClick={showCreateModal} />
                </div>
                <div className="row g-2 align-items-center">
                    {/* Suche + Add Button */}
                    <div className="col-12 col-md-auto d-flex align-items-center">
                        <TextField
                            label="Suche: Name/E-Mail"
                            variant="outlined"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            size="small"
                            fullWidth
                        />
                    </div>

                    {/* Status + Rolle */}
                    <div className="col-12 col-md-auto">
                        <div className="row g-2">
                            <div className="col-6 col-md-auto">
                                <select
                                    className="form-select"
                                    value={statusFilter}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                >
                                    <option value="all">Alle Status</option>
                                    <option value="active">Aktiv</option>
                                    <option value="inactive">Inaktiv</option>
                                </select>
                            </div>

                            <div className="col-6 col-md-auto">
                                <select
                                    className="form-select"
                                    value={roleFilter}
                                    onChange={(e) => setRoleFilter(e.target.value)}
                                >
                                    <option value="all">Alle Rollen</option>
                                    <option value="member">Mitglied</option>
                                    <option value="trainer">Trainer</option>
                                    <option value="admin">Admin</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='bg-white  px-2  pb-4  text-lg-center rounded-5'>
                <div className='row justify-content-center pb-2 infotext legende '>
                    <div className='col-5 col-md-3 text-start ps-lg-5 d-none d-md-block'>Nachname</div>
                    <div className='col-5 col-md-3 text-start d-none d-md-block'>Vorname</div>
                    <div className='col-2 text-start d-none d-md-block'><IoMdMail size={25} /></div>
                    <div className='col-1 text-center d-none d-md-block'><FaReceipt size={22} /></div>
                    <div className='col-2 text-center d-none d-md-block'><FaUserCheck size={22} title="Status" /></div>
                    <div className='col-2 col-md-1'></div>
                </div>
                {filteredPlayers.map((player, index) => (
                    <div key={index} className='row justify-content-center py-2 my-1 player border-top align-items-center'>
                        <div className={`col-10 text-start ps-lg-5 fs-7 d-md-none d-block ${player.role === 2 ? "text-danger" : player.role === 1 ? "text-warning" : "text-dark"} text-break`}>{player.lastName} {player.firstName}</div>
                        <div className={`d-none d-md-block col-md-3 fw-semibold text-start ps-lg-5 ps-3 fs-7 ${player.role === 2 ? "text-danger" : player.role === 1 ? "text-warning" : "text-dark"} text-truncate`} title={player.lastName}>
                            {player.lastName}
                        </div>
                        <div className={`d-none d-md-block col-md-3 text-start fs-7 ${player.role === 2 ? "text-danger" : player.role === 1 ? "text-warning" : "text-dark"} text-truncate`} title={player.firstName}>
                            {player.firstName}
                        </div>
                        <div className='col-2 fs-7 text-truncate text-start d-none d-md-block' title={player.email}>{player.email}</div>
                        <div className='col-1 text-center d-none d-md-block fs-7'>{player.bookingTimes}</div>
                        <div className='col-2 fs-7 text-center d-flex align-items-center justify-content-center d-none d-md-block'>
                            <div className={`me-2 ${player.isActive ? "text-success" : "text-danger"}`} />
                            <span className={`text-uppercase fs-7 ${player.isActive ? "text-success fw-semibold" : "text-danger"}`}>
                                {player.isActive ? "Aktiv" : "Inaktiv"}
                            </span>
                        </div>
                        <div className='col-2 col-md-1 '>
                            < MdEdit
                                className="text-primary edit-button"
                                size={22}
                                onClick={() => showEditModal(player)}
                            />
                        </div>
                    </div>
                ))}
            </div>

            <MemberModal
                show={show}
                closeModal={closeModal}
                setPlayers={setPlayers}
                editMode={editMode}
                playerToEdit={selectedPlayer}
            />
        </div>
    );
};

export default Members;
